import { combineReducers } from 'redux';
import { setAllowChangeProjectStatus } from '../actions';
import { ProjectAction } from '../types';


const canChangeStatus = (state = true, action: ProjectAction) => {
  switch (action.type) {
    case setAllowChangeProjectStatus.type:
      return action.payload;

    default:
      return state;
  }
};


export default combineReducers({
  canChangeStatus,
});
